export enum InfluencerStatsEnum {
  NOT_CONTACTED = 'not_contacted',
  NO_RESPONSE = 'no_response',
  INTERESTED = 'interested',
  INFLUENCER = 'influencer',
  SUPER_INFLUENCER = 'super_influencer',
  BLACKLISTED = 'blacklisted',
}

export enum InfluencerForInfluencedBookStatusEnum {
  SELECTED = 'selected',
  UNSELECTED = 'unselected',
  NA = 'na',
}
